export enum EnumStatusResponse {
    Success = 200,
    AccessDenied = 401,
    NoContent = 204,
    BadRequest = 400,
    UnknownError = 500,
    BadGateway = 502,
    Unavailable = 503,
    NotFound = 404
}